import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';
import { FaTimes } from 'react-icons/fa';
import Image from 'react-bootstrap/Image'
import { InputGroup } from 'react-bootstrap';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from '../../axios';
import { toast } from 'react-toastify';
import { getTodayDateInString } from '../../utils/dateLibrary';
import ReactDatePicker from 'react-datepicker';

export function AddServiceModal() {
    const authToken = localStorage.getItem('access_token');
    const todayDate = getTodayDateInString();
    const validFileExtensions = { image: ['jpg', 'png', 'jpeg', 'webp'] };
    function isValidFileType(fileName, fileType) {
        return fileName && validFileExtensions[fileType].indexOf(fileName.split('.').pop()) > -1;
    }
    const validationSchema = Yup.object().shape({
        imagePath: Yup.mixed()
        .test('image-required', 'Required',
            value => value != undefined || value != null)
        .test('is-valid-type', 'Not a valid image type',
            value => value != null ? isValidFileType(value.name, 'image') : false),
        title: Yup.string().required('Required'),
        description: Yup.string().required('Required'),
        sessionPrice: Yup.number().min(0,'Price must not be less than 0').required('Required'),
        perDayBookings: Yup.number().min(0,'Bookings count must not be less than 0').required('Required'),
        datesAllowed: Yup.array().of(Yup.string()).min(1, "Minimum 1 date required").required("Required"),
    });
    const [show, setShow] = useState(false);
    const [img, setImg] = useState('');
    const [date, setDate] = useState('');
    const [dates, setDates] = useState([]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const imgChange = (e, setFieldValue) => {
        setImg(e.target.files[0]);
        setFieldValue('imagePath', e.currentTarget.files[0]);
    };

    const addItemToList = (setFieldValue) => {
        let tempDates = dates;
        if(date===""){
            
        } else{
            if (tempDates.includes(date)) {
                toast.error('Date already added to the list!');
            } else {
                let day = ("0" + date.getDate()).slice(-2);
                let month = ("0" + (date.getMonth() + 1)).slice(-2);
                let newItem = (day) + "-" + (month) + "-" + date.getFullYear();
                tempDates.push(newItem);
                setDates(tempDates);
                setFieldValue('datesAllowed', tempDates);
                setDate(''); 
            }
        }
    }

    const deleteFromList = (v, setFieldValue) => {
        let tempDates = dates.filter((d) => d !== v);
        setDates(tempDates);
        setFieldValue('datesAllowed', tempDates);
    }

    const addNewService = (values, setSubmitting) => {
        values.datesAllowed = values.datesAllowed.toString();
        axios.post('/services', values, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => {
            if(response.data){
                if (response.status === 200) {
                    toast.success(response.data.message);
                } else {
                    toast.warn('No response from server');
                }
            }
            setSubmitting(false);
            handleClose();
        })
        .catch((error) => {
            toast.error('Something went wrong');
            console.log(error);
            setSubmitting(false);
            handleClose();
        })
        setDates([]);
    };

    return (
        <>
            <div className='d-flex justify-content-end mb-3'>
                <Button variant="primary" onClick={handleShow}>
                    Add New Activity
                </Button>
            </div>

            <Modal show={show} size="lg" onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add New Activity</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={{
                        imagePath: null,
                        title: '',
                        description: '',
                        sessionPrice: '',
                        perDayBookings: '',
                        datesAllowed: [],
                        status: 'published'
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, {setSubmitting}) => addNewService(values, setSubmitting)}
                >
                    {({
                        values,
                        handleChange,
                        handleSubmit,
                        setFieldValue,
                        isSubmitting
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <Row>
                                    <Col md='6'>
                                        <Form.Group className='mb-3'>
                                            <Form.Label>Featured Image</Form.Label>
                                            <Form.Control 
                                                type='file'
                                                name='imagePath'
                                                accept='.jpg,.png,.jpeg,.webp'
                                                onChange={(e) => imgChange(e, setFieldValue)}
                                                disabled={isSubmitting}
                                            />
                                        </Form.Group>
                                        <ErrorMessage name='imagePath' component='p' className='error-message' />
                                    </Col>
                                    <Col md='6' className='text-center'>
                                        {
                                            img ?
                                                <Image src={URL.createObjectURL(img)} style={{ width: '100px' }} />
                                                :
                                                ''
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md='12'>
                                        <Form.Group className='mb-3'>
                                            <Form.Label>Activity Title</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='title'
                                                value={values.title}
                                                onChange={handleChange}
                                                placeholder='Type Service Title'
                                                disabled={isSubmitting}
                                            />
                                        </Form.Group>
                                        <ErrorMessage name='title' component='p' className='error-message' />
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col md='6'>
                                        <Form.Label>Date</Form.Label>
                                            <ReactDatePicker 
                                                selected={date} 
                                                onChange={(val) => setDate(val)} 
                                                dateFormat="dd-MM-yyyy" 
                                                placeholderText="Select a Date"
                                                minDate={new Date()} 
                                                className='form-control'
                                                wrapperClassName='w-100 mb-3'
                                            />
                                        <Button variant="secondary" size="sm" className='mb-3' onClick={() => addItemToList(setFieldValue)}>
                                            Add Date
                                        </Button>
                                        <ErrorMessage name='datesAllowed' component='p' className='error-message' />
                                    </Col>
                                    <Col md='6'>
                                        {
                                            dates.length>0 ?
                                            <h6>Dates Allowed</h6>
                                            :
                                            ''
                                        }
                                        <div className="d-flex flex-wrap align-items-center">
                                            {
                                                dates.map((d, i) => {
                                                    return (
                                                        <div key={i}>
                                                            <Badge className="date-badge me-1">
                                                                <div className="d-flex align-items-center">
                                                                    <span className="me-2">{d}</span>
                                                                    <div
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => deleteFromList(d, setFieldValue)}
                                                                        className={isSubmitting ?? 'd-none'}
                                                                    >
                                                                        <FaTimes />
                                                                    </div>
                                                                </div>
                                                            </Badge>{' '}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md='6'>
                                        <Form.Label>Price Per Session</Form.Label>
                                        <InputGroup className='mb-3'>
                                            <InputGroup.Text>£</InputGroup.Text>
                                            <Form.Control
                                                type='number'
                                                name='sessionPrice'
                                                value={values.sessionPrice}
                                                onChange={handleChange}
                                                placeholder='Price'
                                                disabled={isSubmitting}
                                            />
                                        </InputGroup>
                                        <ErrorMessage name='sessionPrice' component='p' className='error-message' />
                                    </Col>
                                    <Col md='6'>
                                        <Form.Label>Allow Per Day Bookings</Form.Label>
                                        <InputGroup className='mb-3'>
                                            <InputGroup.Text>#</InputGroup.Text>
                                            <Form.Control
                                                type='number'
                                                name='perDayBookings'
                                                value={values.perDayBookings}
                                                onChange={handleChange}
                                                placeholder="Bookings allowed per day"
                                                disabled={isSubmitting}
                                            />
                                        </InputGroup>
                                        <ErrorMessage name='perDayBookings' component='p' className='error-message' />
                                    </Col>
                                </Row>

                                <Form.Group className='mb-3'>
                                    <Form.Label>Activity Description</Form.Label>
                                    <Form.Control 
                                        as='textarea' 
                                        rows={3}
                                        name='description'
                                        value={values.description}
                                        onChange={handleChange} 
                                        disabled={isSubmitting}
                                    />
                                </Form.Group>
                                <ErrorMessage name='description' component='p' className='error-message' />
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" size="sm" type='button' onClick={handleClose} disabled={isSubmitting}>
                                    Close
                                </Button>
                                <Button variant="primary" size="sm" type='submit' disabled={isSubmitting}>
                                    Save Activity
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    );
}
